import React from 'react';

const getErrorInfo = (error) => {
  if (error.customData.interruptionModal) {
    return error?.customData?.interruptionModal;
  }
  if (error.customData.defaultSkyError) {
    return {
      backgroundImage: true,
      title: 'Eita, algo deu errado',
      subtitle: 'Não podemos voltar no tempo, mas na próxima viagem tudo deve voltar ao normal.',
      buttonText: 'Tente novamente',
      customClassNames: {
        container: 'default-sky-error-container',
        content: 'default-sky-error-content'
      }
    };
  }
};

const ManageError = (props) => {
  const { error, setError } = props;
  const modal = getErrorInfo(error);

  const handleButtonClick = () => {
    setError(null);
    if (props.goBack){
      props.goBack();
    }
  };

  return (
    <div>
      <div className={modal?.customClassNames?.container || 'sky-container restrictive-error'}>
        {modal?.imageUrl ? (
          <div className="image">
            <img src={modal?.imageUrl} />
          </div>
        ) : null}
        {modal?.backgroundImage ? (
          <div className="container-image" />
        ) : null}
        <h3>{modal.title}</h3>
        <div className={modal?.customClassNames?.content || 'content'}>
          <p>
            {modal.subtitle}
          </p>
          {modal.moreInfo ? (
            <p>
              {modal.moreInfo}
            </p>
          ) : null}
          <button className="btn btn-light btn-block" onClick={handleButtonClick}>
            {modal.buttonText || 'Voltar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageError;
